import pTimeout from 'p-timeout';
import { getSafeErrorFields } from '../../errors';
import { CreateRecordingIdFailed, type SessionRecordingConfig } from '../../types';
import { logger } from './logger';

export const tryToGetRecordingId = async (
  config: SessionRecordingConfig,
  sessionId: string,
  useTranscriptionServiceV2: boolean
) => {
  try {
    return await pTimeout(config.getRecordingId(sessionId, useTranscriptionServiceV2), {
      milliseconds: 12000,
    });
  } catch (err) {
    logger.error({
      event_type: 'FAILED_TO_CREATE_RECORDING_ID',
      details: getSafeErrorFields(err),
    });
    throw new CreateRecordingIdFailed('could not get recording ID');
  }
};
